import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const ArrowTopLeftIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="0 0 20 20"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M13.84 13.983c.145.144.38.142.528-.006a.373.373 0 0 0 .005-.528L7.423 6.498l6.117-.063a.382.382 0 0 0 .377-.377.364.364 0 0 0-.369-.37l-6.502.067a.913.913 0 0 0-.899.899l-.066 6.502a.364.364 0 0 0 .369.37.383.383 0 0 0 .377-.378l.063-6.117 6.951 6.952Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default ArrowTopLeftIcon;
